import { useState } from "react";
import Sidebar from "./Sidebar";

export default function FaqregisterPage() {
  const [formData, setFormData] = useState({
    category: "",
    question: "",
    answer: "",
  });
  const [message,setMessage] = useState(""); 


  const API_URL = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const response = await fetch(`${API_URL}/api/faq/savefaq`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
        console.log("✅ FAQ posted successfully!");
        setMessage("FAQ posted successfully! ✅");
        setFormData({ category: "", question: "", answer: "" });
      } 
      
      else {
        console.error(result.error || "❌ Failed to post FAQ.");
        setMessage("Failed to post FAQ. ❌");
      }
    } 
    
    catch (error) {
      console.error("Submission Error:", error);
      setMessage("Something went wrong. Please try again later. ❌");
    }
  };

  return (
    <div className="w-screen pt-[2%] px-[1%] h-[100vh] bg-[#f1f2f6] flex flex-row">
      <Sidebar />

      <div className="flex w-full ml-2">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-6xl bg-white p-6 rounded-lg shadow-md flex items-start gap-6"
        >
          <div className="flex-1 space-y-4">
            <div className="w-full">
              <label htmlFor="category" className="block text-gray-700 mb-1">
                Category
              </label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded text-gray-700 bg-white focus:outline-none focus:ring-2 focus:black"
                required
              >
                <option value="">-- Select Category --</option>
                <option value="aoc">About the Company</option>
                <option value="innovator">Nextgen Innovators</option>
                <option value="juniors">Nextgen Juniors</option>
                <option value="skillsphere">Skillsphere Assessment</option>
              </select>
            </div>

            <textarea
              name="question"
              placeholder="Question"
              value={formData.question}
              onChange={handleChange}
              className="w-full p-2 border rounded h-40"
              required
            />

            <textarea
              name="answer"
              placeholder="Answer"
              value={formData.answer}
              onChange={handleChange}
              className="w-full p-2 border rounded h-40"
              required
            />
          </div>

          <div className="flex flex-col items-end">
            <button
              type="submit"
              className="bg-green-500 hover:bg-green-600 text-white p-2 px-16 rounded shadow-md"
            >
              Submit FAQ
            </button>
            {message && (
              <p className={`mt-2 text-sm ${message.includes("✅") ? "text-green-600" : "text-red-600"}`}>
                {message}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
